var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 660,
    height: 580,
    viewBox: "0 0 660 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M329.056 303.578C345.099 324.016 350.583 350.815 343.858 375.913L310.921 498.838C309.161 505.407 300.658 507.149 296.456 501.801L73.3341 217.828C57.2728 197.387 51.7792 170.573 58.5077 145.462L91.5003 22.3325C93.2609 15.7619 101.767 14.0212 105.967 19.372L329.056 303.578Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.77 588.971C293.494 563.874 288.01 537.074 271.967 516.636L48.8785 232.43C44.6783 227.079 36.1721 228.82 34.4115 235.391L3.60287 350.37C-3.12746 375.488 2.37115 402.309 18.4421 422.752L241.582 706.601C245.784 711.947 254.285 710.204 256.045 703.636L286.77 588.971Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.545 288.743C357.746 294.091 366.249 292.349 368.009 285.78L400.947 162.855C407.672 137.757 402.188 110.958 386.145 90.5197L163.056 -193.686C158.856 -199.037 150.35 -197.296 148.589 -190.726L115.596 -67.5957C108.868 -42.4848 114.362 -15.6715 130.423 4.77017L353.545 288.743Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M377.947 385.05C384.672 359.953 402.82 339.486 426.933 329.808L762.238 195.219C768.551 192.685 775.047 198.446 773.286 205.017L740.294 328.147C733.565 353.257 715.401 373.732 691.271 383.404L356.055 517.771C349.743 520.301 343.25 514.541 345.01 507.972L377.947 385.05Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M320.858 598.108C327.583 573.011 345.732 552.544 369.844 542.866L705.149 408.277C711.462 405.744 717.958 411.504 716.198 418.075L685.388 533.058C678.658 558.176 660.485 578.654 636.346 588.323L301.177 722.573C294.864 725.102 288.374 719.342 290.134 712.774L320.858 598.108Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M435.036 171.992C441.76 146.895 459.909 126.428 484.022 116.749L819.327 -17.8388C825.639 -20.3728 832.136 -14.6121 830.375 -8.0415L797.383 115.088C790.654 140.199 772.49 160.673 748.36 170.346L413.144 304.713C406.831 307.243 400.339 301.483 402.099 294.914L435.036 171.992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBg);
export default __webpack_public_path__ + "static/media/about-bg.8a3f230be79afbef7de76f6fe6f29adf.svg";
export { ForwardRef as ReactComponent };